import { IgAlert } from "@intelligems/ig-theme";
import { Stack } from "@mui/material";

import {
  useGetCheckoutBlockViewedAvailableDateLabel,
  useIsCheckoutBlockViewedDataIncomplete,
} from "@src/features/analytics/hooks/use-checkout-block-viewed-available";

export const CheckoutBlockViewedNotAvailable = () => {
  const show = useIsCheckoutBlockViewedDataIncomplete();
  const dateLabel = useGetCheckoutBlockViewedAvailableDateLabel();

  if (!show) {
    return null;
  }

  return (
    <Stack sx={{ marginX: 8, marginY: 4 }}>
      <IgAlert
        alertKey="CheckoutBlockViewedNotAvailable"
        message={`Checkout block view data is not available prior to ${dateLabel}.`}
        severity="warning"
      />
    </Stack>
  );
};
